module.exports = __webpack_public_path__ + "static/media/everstone.55610b9d.svg";